import React, { Component } from 'react';
import { Button, Modal } from 'semantic-ui-react'
import './index.css'

class ConfirmRemoveTagModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      finalConfirmationShown: false
    }
  }

  showFinalConfirmation = () => {
    this.setState({
      finalConfirmationShown: true
    })
  }

  hideFinalConfirmation = () => {
    this.setState({
      finalConfirmationShown: false
    })
  }

  renderFirstConfirmation = () => {
    return (
      <Modal.Content>
        <div><span className="warning-label">Warning: </span><span>Removing the <strong>'Active'</strong> tag from this plan will cause all the controls and associated verification information, <strong>from this plan</strong>, to be deleted from the CVS system.</span></div>
        <div>Are you sure you would like to <strong>REMOVE</strong> the <strong>'Active'</strong> tag and <strong>DELETE</strong> this information from CVS?</div>
        <div>This cannot be undone.</div>
      </Modal.Content>
    )
  }

  renderFinalConfirmation = () => {
    return (
      <Modal.Content>
        <div>Are you sure you would like to <strong>REMOVE</strong> the <strong>'Active'</strong> tag and <strong>DELETE</strong> this information from CVS?</div>
      </Modal.Content>
    )
  }

  renderFirstActions = () => {
    const { onClose } = this.props;
    const { showFinalConfirmation } = this;
    return (
      <Modal.Actions>
        <Button fluid size='medium' className="new-plan-button" onClick={onClose}>
          Back
        </Button>
        <Button color='red' fluid size='medium' className="new-plan-button" onClick={showFinalConfirmation}>
          Remove
        </Button>
      </Modal.Actions>
    )
  }

  renderFinalActions = () => {
    const { onProceed } = this.props;
    const { hideFinalConfirmation } = this;
    return (
      <Modal.Actions>
        <Button fluid size='medium' className="new-plan-button" onClick={hideFinalConfirmation}>
          Back
        </Button>
        <Button color='red' fluid size='medium' className="new-plan-button" onClick={onProceed}>
          Remove
        </Button>
      </Modal.Actions>
    )
  }

  render() {
    const { shown, onClose } = this.props;
    const { finalConfirmationShown } = this.state;
    const { hideFinalConfirmation } = this;
    return (
      <Modal className='confirm-modal' size="tiny" open={ shown }>
        <Modal.Header>Confirm delete tag</Modal.Header>
        { !finalConfirmationShown && this.renderFirstConfirmation() }
        { finalConfirmationShown && this.renderFinalConfirmation() }
        { !finalConfirmationShown && this.renderFirstActions() }
        { finalConfirmationShown && this.renderFinalActions() }
        { !finalConfirmationShown && <i className="delete icon" onClick={ onClose }></i> }
        { finalConfirmationShown && <i className="delete icon" onClick={ hideFinalConfirmation }></i> }
      </Modal>
    )
  }
}

export default ConfirmRemoveTagModal



// WEBPACK FOOTER //
// ./src/components/confirm_remove_tag_modal/index.js